import * as React from 'react';
import { useState } from 'react';
import { ErrorBoundary, Viewport, ViewSmall, ViewLarge } from 'bernie-view';
import { useDialog } from '@shared-ui/dialog-context';

import { UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkExpandoCard } from 'uitk-react-expando';
import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkSpacing } from 'uitk-react-spacing';

import { BaseFlexibleSearchGrid } from './';
import { useStores } from 'utility/hooks';
import { trackAnalytics } from 'utility';

export const FlexibleSearchGrid = () => {
  const { routeStore, flexibleSearchResultsStore, analytics: analyticsStore } = useStores();
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog('flexible-search-grid-dialog');
  const [isLargeExpandoOpen, setLargeExpandoState] = useState(false);
  const { gridTrigger, subTitle, title } = flexibleSearchResultsStore;
  const flexGridName = 'flexible-search-grid';

  const toggleLargeExpando = () => {
    if (!isLargeExpandoOpen) {
      trackAnalytics(gridTrigger.expandAnalytics, analyticsStore);
    } else {
      trackAnalytics(gridTrigger.collapseAnalytics, analyticsStore);
    }
    setLargeExpandoState(!isLargeExpandoOpen);
  };

  const toggleDialog = () => {
    if (!isDialogOpen) {
      trackAnalytics(gridTrigger.expandAnalytics, analyticsStore);
    }
    dialogActions.toggleDialog();
  };

  const onDialogClose = () => {
    trackAnalytics(gridTrigger.collapseAnalytics, analyticsStore);
    routeStore.closeDialog();
  };

  return (
    <ErrorBoundary label="Flexible Search Grid">
      <div data-test-id="flexible-search-grid-container">
        <Viewport>
          <ViewSmall>
            <UitkExpandoCard
              className={flexGridName}
              expandoDescription={
                <DialogComponent>
                  <UitkFullscreenDialog strictFullscreen={true} dialogShow={true}>
                    <UitkToolbar
                      action={onDialogClose}
                      type={ToolbarType.CLOSE}
                      header={title}
                      key={`${flexGridName}-toolbar`}
                    />
                    <BaseFlexibleSearchGrid displayFooter={true} key={`${flexGridName}-content`} />
                  </UitkFullscreenDialog>
                </DialogComponent>
              }
              expandoTitle={title}
              expandoSubtitle={subTitle}
              handleClick={toggleDialog}
              isVisible={isDialogOpen}
            />
          </ViewSmall>
          <ViewLarge>
            <UitkExpandoCard
              className={flexGridName}
              expandoDescription={<BaseFlexibleSearchGrid />}
              expandoTitle={title}
              expandoSubtitle={subTitle}
              handleClick={toggleLargeExpando}
              isVisible={isLargeExpandoOpen}
            />
          </ViewLarge>
        </Viewport>
      </div>
      <UitkSpacing margin={{ block: 'six' }}>
        <hr aria-hidden="true" />
      </UitkSpacing>
    </ErrorBoundary>
  );
};

FlexibleSearchGrid.displayName = 'FlexibleSearchGrid';
